import { Tab } from '@mui/material';
import type { TabProps } from '@mui/material';
import type { FC } from 'react';

function a11yProps(index: number, prefix: string): Record<string, string> {
  return {
    id: `${prefix}-tab-${index}`,
    'aria-controls': `${prefix}-tabpanel-${index}`,
  };
}

const A11yTab: FC<A11yTabProps> = ({ index, prefix, ...other }) => (
  <Tab {...other} {...a11yProps(index, prefix)} />
);

export interface A11yTabProps extends TabProps {
  index: number;
  prefix: string;
}

export default A11yTab;
